import { z } from "zod";

import {
  CartTransformFeaturesSchema,
  CartTransformSchema,
} from "../../../schemas/organization";

export const GetCartTransformResponseBodySchema = z.object({
  cartTransforms: CartTransformSchema.array(),
  cartTransformFeatures: CartTransformFeaturesSchema,
});

export type GetCartTransformResponseBodyType = z.infer<
  typeof GetCartTransformResponseBodySchema
>;
